// extracted by mini-css-extract-plugin
export default {"language":"language_language__4bBVH","languages":"language_languages__O7zWu"};